import { withStyles } from '@mui/styles'
import { ListItem } from '@mui/material'

export const StyledListItem = withStyles({
    selected: {
        backgroundColor: '#7FA1C7',
    },
    root: {
        '&$selected, &$selected:hover': {
            backgroundColor: '#7FA1C7',
        },
    },
})(ListItem)
